import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
    selector: 'app-loading-particles',
    templateUrl: './loading-particles.component.html',
    styleUrl: './loading-particles.component.scss',
    standalone: false
})
export class LoadingParticlesComponent implements OnInit, OnDestroy {
  @Input()
  promptName!: string;

  @Input()
  selectedModel: string | undefined;

  slowLLMMessage = "Using GPT-4 models can take a little longer";
  typedSlowLLMMessage = '';
  showSlowLLMMessage: boolean | undefined = false;

  blinkingBlobTypingTimer: any;
  typeWriterTimer: any;
  typeWriterInterval: any;

    // Note: If we go above 30 particles (inc. the Kyloe logo ones), the @for loop needs increasing in the SCSS
  noOfCircles = new Array(15);
  noOfDashedCircles = new Array(3);

  ngOnInit(): void {
    this.typeSlowMessage();
  }

  protected typeSlowMessage() {
    if (this.selectedModel?.includes('gpt-4')) {
      this.resetSlowMessageTimers();
      this.blinkingBlobTypingTimer = setTimeout(() => {
        this.showSlowLLMMessage = true;
      }, 2000);
      this.typeWriterTimer = setTimeout(() => {
        this.typeWriter();
      }, 5000);
    }
  }

  private typeWriter() {
    let index = 0;
    this.typeWriterInterval = setInterval(() => {
      if (index < this.slowLLMMessage?.length) {
        this.typedSlowLLMMessage += this.slowLLMMessage.charAt(index);
        index++;
      } else {
        clearInterval(this.typeWriterInterval);
      }
    }, 50);
  }

  private resetSlowMessageTimers() {
    clearTimeout(this.blinkingBlobTypingTimer);
    clearTimeout(this.typeWriterTimer);
    clearInterval(this.typeWriterInterval);
    this.typedSlowLLMMessage = '';
    this.showSlowLLMMessage = false;
  }

  ngOnDestroy(): void {
    this.resetSlowMessageTimers();
  }
}
